import { atom } from 'jotai';

import { type LoggedUser } from '@/features/user/types/user-types';

export const loggedUserAtom = atom<LoggedUser | null>(null);
